import Alpine, { AlpineComponent } from 'alpinejs';
import { NewsletterRules } from '../../types/form';
import { iodine } from '../../helpers/validation';
import { FormFieldValidationAlpine, getFieldValidation } from '../../helpers/fieldValidation';

interface NewsletterFormAlpine extends AlpineComponent<Record<string, any>> {
    [key: string]: any;
    form: HTMLFormElement;
    confirmation: boolean;
    validate: () => void;
}

const rules: NewsletterRules = {
    email: ['required', 'email', 'noPlusInEmail'],
    zip: ['required', 'regexMatch:\\d{5}'],
    city: ['required'],
};

document.addEventListener('alpine:init', () => {
    // @ts-ignore
    Alpine.data('initNewsletterForm', (form: HTMLFormElement): NewsletterFormAlpine & FormFieldValidationAlpine => {
        return {
            ...getFieldValidation(rules),
            ...{
                form,
                confirmation: false,
                async validate(): Promise<void> {
                    const email = this.$refs.email as HTMLInputElement;
                    // as zip is in x-data=simpleAutocomplete, it is not accessible in refs any more
                    const zip = form.querySelector('[name$="[zip]"]') as HTMLInputElement;
                    const city = this.$refs.city as HTMLInputElement;
                    const validation = iodine.assert(
                        {
                            email: email.value,
                            zip: zip.value,
                            city: city.value,
                        },
                        {
                            email: rules.email,
                            zip: rules.zip,
                            city: rules.city,
                        },
                    );
                    const submitButton = form.querySelector('button[type=submit]') as HTMLButtonElement;
                    if (validation.valid) {
                        submitButton.disabled = true;
                        form.submit();
                    } else {
                        submitButton.disabled = false;
                        this.displayErrors(validation);
                    }
                },
            },
        };
    });
});
